import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EMPTY = { full_name: "", email: "", company: "", message: "" };

const validate = (form, consent) => {
  if (!form.full_name || !form.email || !form.company || !form.message) {
    return "Please complete all required fields.";
  }
  if (!consent) return "Please agree to the Privacy Policy to continue.";
  return null;
};

const errorMessage = (err) =>
  (err?.response?.status === 429 && err.response.data?.detail) || "Something went wrong. Please try again.";

// Contact form state, validation and submission (with honeypot + rate-limit handling).
export const useContactForm = ({ serviceInterest, setServiceInterest }) => {
  const [form, setForm] = useState(EMPTY);
  const [honeypot, setHoneypot] = useState("");
  const [consent, setConsent] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [note, setNote] = useState("");

  const update = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    const problem = validate(form, consent);
    if (problem) {
      toast.error(problem);
      return;
    }
    setSubmitting(true);
    try {
      await axios.post(`${API}/contact`, {
        ...form,
        service_interest: serviceInterest || null,
        website: honeypot || null,
      });
      toast.success("Inquiry received. Our engineers will be in touch shortly.");
      setNote("Thanks — your inquiry has been queued for our engineering team.");
      setForm(EMPTY);
      setServiceInterest("");
      setConsent(false);
    } catch (err) {
      toast.error(errorMessage(err));
    } finally {
      setSubmitting(false);
    }
  };

  return { form, update, honeypot, setHoneypot, consent, setConsent, submitting, note, submit };
};
